import { useFontSize } from "../contexts/FontSizeContext";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * Toggle segmentato della dimensione testo, allineato visivamente al
 * LanguageToggle: stesso contenitore e stessa altezza dei bottoni.
 * I bottoni hanno altezza fissa (h-6) cosi la differenza tra glifi non
 * deforma il controllo; Piccolo/Medio/Grande sono comunicati dalla scala.
 */
export function FontSizeToggle() {
	const { fontScale, setFontScale } = useFontSize();
	const { t } = useLanguage();

	const baseBtn =
		"h-6 min-w-[30px] flex items-center justify-center font-bold leading-none";

	return (
		<div className="inline-flex items-center bg-secondary border border-border rounded-sm overflow-hidden">
			<button
				type="button"
				onClick={() => setFontScale("small")}
				title={t("textSizeSmall")}
				aria-label={t("textSizeSmall")}
				aria-pressed={fontScale === "small"}
				className={`${baseBtn} text-xs ${
					fontScale === "small"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				A
			</button>
			<div className="w-px self-stretch bg-border" />
			<button
				type="button"
				onClick={() => setFontScale("medium")}
				title={t("textSizeMedium")}
				aria-label={t("textSizeMedium")}
				aria-pressed={fontScale === "medium"}
				className={`${baseBtn} text-sm ${
					fontScale === "medium"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				A
			</button>
			<div className="w-px self-stretch bg-border" />
			<button
				type="button"
				onClick={() => setFontScale("large")}
				title={t("textSizeLarge")}
				aria-label={t("textSizeLarge")}
				aria-pressed={fontScale === "large"}
				className={`${baseBtn} text-lg ${
					fontScale === "large"
						? "bg-volt text-white"
						: "text-muted-foreground hover:text-foreground"
				}`}
			>
				A
			</button>
		</div>
	);
}
